export const COMPANY_LOGO_SIZE = 50
export const COMPANY_BANNER_SIZE = 100
